<script>
import eventBus from './common/eventBus';
import loading from './components/loading';
import jcNavbar from './modules/global/navbar';
export default {
    created() {
        this.$store.dispatch('zft/getCityList', {threeLevel: false})
        this.init();
    },
    data() {
        return {
        };
    },
    methods: {
        init() {
            eventBus.$on('requestError', mes => {
                const error = mes || 'server error';
                this.$alert(mes, '', {
                    type: 'error',
                    showCancelButton: true,
                    showConfirmButton: false,
                    cancelButtonText: '确认',
                    cancelButtonClass: 'el-button--danger'
                });
            });
            eventBus.$on('skipPage', () => {
                this.clearToken();
                this.$router.push({
                    path: '/login'
                });
            });
        },
        clearToken() {
            const tk = localStorage.getItem('tk');
            tk && localStorage.removeItem('tk');
            this.$store.commit('SET_USER_INFO', {
                token: ''
            });
        }
    },
    computed: {
        isSideBarShow() {
            return this.$store.getters.env.isSideBarShow;
        },
        isSingle() {
           return  this.$route.meta.single;
        },
        isLogin() {
            return this.$store.getters['userInfo'].token;
        },
        loadPage() {
            return this.$store.getters['zft/menuList'].length > 0
        }
    },
    components: {
        jcHeader: () => import('./modules/global/header'),
        jcNavbar, loading
    }
};
</script>
<template>
  <div id="app" class="flex">
      <jc-header v-if="!isSingle && isLogin"></jc-header>
      <div class="content" :class="{full: !isSideBarShow}" v-if="!isSingle && loadPage">
          <jc-navbar></jc-navbar>
          <div class="main-container">
              <router-view></router-view>
          </div>
      </div>
      <router-view v-else></router-view>
      <loading></loading>
  </div>
</template>
<style lang="stylus" scoped>
@import './common/global.styl';
.flex
   display flex
   flex-direction column
   overflow hidden
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  color #2c3e50
  height 100vh
  .content
      margin-left 200px
      transition margin-left 0.3s ease
      &.full
          margin-left 60px
          transition margin-left 0.6s ease
      .main-container
          height calc(100vh - 50px)
          overflow-y scroll

</style>
